module.exports = __webpack_public_path__ + "static/img/pro4.0545b83.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/base/pro4.png
// module id = 1649
// module chunks = 2